import React from 'react';
import { Link } from 'react-router-dom';
import { FacebookIcon, InstagramIcon, TwitterIcon, CreditCardIcon, LockIcon, TruckIcon } from 'lucide-react';
const Footer = () => {
  return <footer className="bg-gray-800 text-white pt-12 pb-8" data-id="element-26">
      <div className="container mx-auto px-4" data-id="element-27">
        {/* Trust Badges */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 pb-8 border-b border-gray-700" data-id="element-28">
          <div className="flex items-center space-x-4" data-id="element-29">
            <div className="bg-gray-700 p-3 rounded-full" data-id="element-30">
              <CreditCardIcon className="h-6 w-6 text-blue-400" data-id="element-31" />
            </div>
            <div data-id="element-32">
              <h4 className="font-semibold" data-id="element-33">Secure Payments</h4>
              <p className="text-gray-300 text-sm" data-id="element-34">Multiple payment methods</p>
            </div>
          </div>
          <div className="flex items-center space-x-4" data-id="element-35">
            <div className="bg-gray-700 p-3 rounded-full" data-id="element-36">
              <LockIcon className="h-6 w-6 text-blue-400" data-id="element-37" />
            </div>
            <div data-id="element-38">
              <h4 className="font-semibold" data-id="element-39">Trusted Marketplace</h4>
              <p className="text-gray-300 text-sm" data-id="element-40">
                Verified sellers and products
              </p>
            </div>
          </div>
          <div className="flex items-center space-x-4" data-id="element-41">
            <div className="bg-gray-700 p-3 rounded-full" data-id="element-42">
              <TruckIcon className="h-6 w-6 text-blue-400" data-id="element-43" />
            </div>
            <div data-id="element-44">
              <h4 className="font-semibold" data-id="element-45">Fast Delivery</h4>
              <p className="text-gray-300 text-sm" data-id="element-46">
                Reliable shipping partners
              </p>
            </div>
          </div>
        </div>
        {/* Footer Links */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 py-8" data-id="element-47">
          <div data-id="element-48">
            <h3 className="text-lg font-bold mb-4" data-id="element-49">MarketHub</h3>
            <p className="text-gray-300 text-sm mb-4" data-id="element-50">
              Connecting quality sellers with happy customers. Your trusted
              marketplace for unique products.
            </p>
            <div className="flex space-x-4" data-id="element-51">
              <a href="https://facebook.com" className="text-gray-300 hover:text-white" data-id="element-52">
                <FacebookIcon className="h-5 w-5" data-id="element-53" />
              </a>
              <a href="https://instagram.com" className="text-gray-300 hover:text-white" data-id="element-54">
                <InstagramIcon className="h-5 w-5" data-id="element-55" />
              </a>
              <a href="https://twitter.com" className="text-gray-300 hover:text-white" data-id="element-56">
                <TwitterIcon className="h-5 w-5" data-id="element-57" />
              </a>
            </div>
          </div>
          <div data-id="element-58">
            <h3 className="text-lg font-bold mb-4" data-id="element-59">Shop</h3>
            <ul className="space-y-2 text-gray-300" data-id="element-60">
              <li data-id="element-61">
                <Link to="/categories" className="hover:text-white" data-id="element-62">
                  All Categories
                </Link>
              </li>
              <li data-id="element-63">
                <Link to="/categories" className="hover:text-white" data-id="element-64">
                  Fashion & Accessories
                </Link>
              </li>
              <li data-id="element-65">
                <Link to="/categories" className="hover:text-white" data-id="element-66">
                  Home & Living
                </Link>
              </li>
              <li data-id="element-67">
                <Link to="/categories" className="hover:text-white" data-id="element-68">
                  Electronics
                </Link>
              </li>
              <li data-id="element-69">
                <Link to="/categories" className="hover:text-white" data-id="element-70">
                  Handmade Crafts
                </Link>
              </li>
            </ul>
          </div>
          <div data-id="element-71">
            <h3 className="text-lg font-bold mb-4" data-id="element-72">Customer Service</h3>
            <ul className="space-y-2 text-gray-300" data-id="element-73">
              <li data-id="element-74">
                <Link to="/faq" className="hover:text-white" data-id="element-75">
                  FAQ
                </Link>
              </li>
              <li data-id="element-76">
                <Link to="/shipping" className="hover:text-white" data-id="element-77">
                  Shipping & Returns
                </Link>
              </li>
              <li data-id="element-78">
                <Link to="/contact" className="hover:text-white" data-id="element-79">
                  Contact Us
                </Link>
              </li>
              <li data-id="element-80">
                <Link to="/privacy" className="hover:text-white" data-id="element-81">
                  Privacy Policy
                </Link>
              </li>
              <li data-id="element-82">
                <Link to="/terms" className="hover:text-white" data-id="element-83">
                  Terms of Service
                </Link>
              </li>
            </ul>
          </div>
          <div data-id="element-84">
            <h3 className="text-lg font-bold mb-4" data-id="element-85">Sellers</h3>
            <ul className="space-y-2 text-gray-300" data-id="element-86">
              <li data-id="element-87">
                <Link to="/become-seller" className="hover:text-white" data-id="element-88">
                  Become a Seller
                </Link>
              </li>
              <li data-id="element-89">
                <Link to="/seller-guide" className="hover:text-white" data-id="element-90">
                  Seller Guide
                </Link>
              </li>
              <li data-id="element-91">
                <Link to="/seller-login" className="hover:text-white" data-id="element-92">
                  Seller Login
                </Link>
              </li>
              <li data-id="element-93">
                <Link to="/seller-resources" className="hover:text-white" data-id="element-94">
                  Resources
                </Link>
              </li>
            </ul>
          </div>
        </div>
        {/* Newsletter */}
        <div className="border-t border-gray-700 pt-8 pb-4" data-id="element-95">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center" data-id="element-96">
            <div data-id="element-97">
              <h3 className="text-lg font-bold mb-2" data-id="element-98">
                Subscribe to our newsletter
              </h3>
              <p className="text-gray-300 text-sm" data-id="element-99">
                Get the latest updates on new products and special sales
              </p>
            </div>
            <div className="flex" data-id="element-100">
              <input type="email" placeholder="Your email address" className="flex-grow px-4 py-2 rounded-l-md text-gray-800 focus:outline-none" data-id="element-101" />
              <button className="bg-blue-600 hover:bg-blue-700 px-4 py-2 rounded-r-md font-medium transition duration-200" data-id="element-102">
                Subscribe
              </button>
            </div>
          </div>
        </div>
        {/* Copyright */}
        <div className="text-center text-gray-400 text-sm pt-8" data-id="element-103">
          <p data-id="element-104">© {new Date().getFullYear()} MarketHub. All rights reserved.</p>
        </div>
      </div>
    </footer>;
};
export default Footer;